/* Current, official and source-of-truth list of feature IDs. */
export const FEATURES_LIST = {
  GLOBAL_AUDIT_MODAL: 'global-audit-modal',
  PROCESSING_VIEW: 'processing-view',
  ADD_ESCALATION_DRAWER: 'add-escalation-drawer',
  NON_APPLICANT_NAME_FIELDS: 'non-applicant-name-fields',
  DISABLE_LEGACY_ONBLUR_TO_SAVE: 'disable-legacy-onblur-to-save',
  LIFE_OF_LOAN_FLOOD_ZONE_CERT: 'life-of-loan-flood-zone-cert',
  FIRST_AMERICAN_TITLE: 'first-american-title',
}

// Array with all the values for easier init of all features
export const ALL_FEATURES = Object.values(FEATURES_LIST)
